import React from 'react';
import styled from 'styled-components';
import Input from './Input';

interface PlaceSearchInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocusAction?: () => void;
  placeholder: string;
  name: string;
  label: string;
  secondary?: boolean;
  error?: string;
}

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const PlaceSearchInput: React.FC<PlaceSearchInputProps> = ({
  value,
  onChange,
  onFocusAction,
  placeholder,
  name,
  label,
  secondary = false,
  error
}) => {
  const handleClick = () => {
    if (onFocusAction) {
      onFocusAction();
    }
  };

  return (
    <InputWrapper onClick={handleClick}>
      <Input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        name={name}
        label={label}
        secondary={secondary}
        error={error}
      />
    </InputWrapper>
  );
};

export default PlaceSearchInput;